import React, { useEffect } from 'react';
import type { HubTagTemplate } from 'dorian-shared/types/branch/HubOption';
import { bugTracker } from 'services/bugTracker/BugTrackerService';
import { useMemoryIconsContext } from 'contexts/MemoryIconsContext/MemoryIconsContext';
import { TagChip, TagChipSize } from 'components/ui/TagChip/TagChip';
import './HubOptionTagChip.scss';

type HubOptionTagChipProps = {
  template: HubTagTemplate | undefined;
  size?: TagChipSize;
  className?: string;
  tagTemplateId?: number;
};

function OrphanTagChip({ tagTemplateId, size, className }: { tagTemplateId?: number; size: TagChipSize; className?: string }) {
  useEffect(() => {
    bugTracker().reportError({
      name: 'HubOptionTagChip',
      message: `Orphan tagTemplateId rendered in HubOption tags: ${tagTemplateId ?? 'unknown'}`,
    });
  }, [tagTemplateId]);

  return (
    <span
      className={`tag-chip-orphan tag-chip-orphan--${size}${className ? ` ${className}` : ''}`}
      title="Tag template is missing"
    >
      [deleted tag]
    </span>
  );
}

export function HubOptionTagChip({
  template, size = 'md', className, tagTemplateId,
}: HubOptionTagChipProps) {
  const { memoryIcons } = useMemoryIconsContext();

  if (!template) {
    return <OrphanTagChip tagTemplateId={tagTemplateId} size={size} className={className} />;
  }

  const iconUrl = template.iconId != null
    ? memoryIcons.find((icon) => icon.id === template.iconId)?.url ?? null
    : null;

  return (
    <TagChip
      text={template.text ?? template.name}
      color={template.color ?? null}
      iconUrl={iconUrl}
      size={size}
      className={className}
      title={template.name}
    />
  );
}
